package one.healthium.reminders.data.mapper

import kotlinx.datetime.DatePeriod
import one.healthium.reminders.data.dto.ReminderTypeDto
import one.healthium.reminders.data.dto.RemindersDto
import one.healthium.reminders.domain.ReminderModel
import one.healthium.reminders.domain.ReminderNotificationModel
import one.healthium.reminders.domain.ReminderType
import one.healthium.reminders.domain.Time
import one.primehealth.app.DeepLink
import kotlin.time.Duration.Companion.minutes

internal class ReminderMapper {
    fun dtoToModel(dto: RemindersDto) = dto.reminders.map { reminder ->
        ReminderModel(
            notifications = reminder.notifications.map { notification ->
                ReminderNotificationModel(
                    title = notification.title,
                    description = notification.description,
                )
            },
            deepLink = reminder.deepLink?.let { DeepLink.parse(it) },
            type = when (val type = reminder.type) {
                is ReminderTypeDto.Periodic -> ReminderType.Periodic(
                    time = mapTime(type.time),
                    timeWindow = type.timeWindowMinutes?.minutes,
                    period = DatePeriod.parse(type.period)
                )

                is ReminderTypeDto.OneTime -> ReminderType.OneTime(
                    time = mapTime(type.time),
                    timeWindow = type.timeWindowMinutes?.minutes,
                )
            },
        )
    }

    private fun mapTime(time: String): Time {
        val (hour, minute) = time.split(":").map { it.toInt() }
        return Time(hour, minute)
    }
}